import { Dialog as CssModulesDialog, DialogProps } from '@sunwebgroup/uds-ui/dialog'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/dialog' instead.
 */
const StyledDialog = styled(CssModulesDialog)<DialogProps>``

export default StyledDialog
